import { gql } from 'apollo-angular';

export const PURCHASE_HISTORY_DOWNLOAD_URL = gql`
  query PurchaseHistoryDownload($rfpId: Long!) {
    purchaseHistoryDownload(rfpId: $rfpId) {
      url
    }
  }
`;
